module.exports = "/images/warning-icon.svg?0e0578797b8b7edea01b589e1814363a";